<template>
  <v-card class="elevation-12">
    <v-progress-linear :active="isLoading" color="loader" indeterminate />
    <v-card-text class="text-left">
      <v-row>
        <v-col>
          <text-view
              :display="profile.userName"
              :label="$t('Имя пользователя в системе')"
              multiline
              prepend-icon="person" />
          <text-view
              :display="profile.contactPerson"
              :label="$t('Контактное лицо (ФИО)')"
              multiline
              prepend-icon="person" />
          <text-view
              :display="profile.documentPersonIdentity"
              multiline
              md="6"
              :label="$t('Серия и номер паспорта')"
              prepend-icon="assignment_ind" />
          <text-view
              :display="$t(profile.isRegistered
                ? 'Зарегистрирован'
                : 'Не зарегистрирован')"
              :label="$t('Статус')"
              multiline
              prepend-icon="device_hub" />
          <text-view
              :display="profile.participantType
                ? $t(PARTICIPANT_TYPE_ENUM[profile.participantType])
                : null"
              :label="$t('Роль пользователя в системе')"
              multiline
              prepend-icon="device_hub" />
          <text-view
              :display="profile.email"
              :label="$t('Email пользователя')"
              multiline
              prepend-icon="alternate_email" />
          <text-view
              :display="$t(profile.emailConfirmed
                ? 'Подтвержден'
                : 'Не подтвержден')"
              multiline
              :label="$t('Подтверждение пользователем электронного адреса')" />
          <text-view
              :display="profile.phone"
              :label="$t('Контактный телефон')"
              multiline
              prepend-icon="settings_phone" />
        </v-col>
        <v-col>
          <text-view
              :display="$t(profile.isTopManager
                ?'Да'
                :'Нет')"
              :label="$t('Уполномоченным представителем является Единоличный исполнительный орган')"
              multiline
              prepend-icon="device_hub" />
          <date-view
              :display="profile.validTo"
              :label="$t('Дата окончания доступа пользователя к системе')"
              multiline
              prepend-icon="event" />
          <date-view
              :display="profile.lastLoginDate"
              :label="$t('Дата последнего входа пользователя в систему')"
              multiline
              prepend-icon="event" />
          <text-view
              :display="$t(SUBSCRIPTIONS_TYPE_ENUM[profile.subscriptionsStatus])"
              :label="$t('Подписка на рассылку')"
              multiline
              prepend-icon="mail" />
        </v-col>

      </v-row>
      <v-row />
    </v-card-text>
  </v-card>
</template>

<script>
  import TextView from '@/components/reused/ui/TextView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import { PARTICIPANT_TYPE_ENUM, SUBSCRIPTIONS_TYPE_ENUM } from '@/constants/enums'

  export default {
    components: {
      TextView,
      DateView
    },
    props: {
      user: {
        type: Object,
        required: true
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        PARTICIPANT_TYPE_ENUM,
        SUBSCRIPTIONS_TYPE_ENUM
      }
    },
    computed: {
      profile () {
        const personIdentity = this.user.documentPersonIdentity
        return {
          ...this.user,
          documentPersonIdentity: personIdentity
            ? `${personIdentity.substring(0, 4)} ${personIdentity.substring(4)}`
            : null
        }
      }
    }
  }
</script>
